import React from 'react';
import PropTypes from 'prop-types';
import DispatchModalList from './DispatchModalList';

const DispatchJobsList = ({
  jobs,
  handleUpdateModalState,
  selectedJobs,
  currentJobs = [],
  activeTeam,
}) => {
  const columns = [
    { selector: 'prd_id', title: 'Projet', type: 'string' },
    { selector: 'sequence', title: 'Séq.', type: 'string' },
    { selector: 'step', title: 'Étape', type: 'number' },
    { selector: 'resource', title: 'Ress.', type: 'number' },
    { selector: 'description', title: 'Description', type: 'string' },
    { selector: 'client', title: 'Client', type: 'string' },
    { selector: 'city', title: 'Ville/Province', type: 'string' },
  ];

  const MAX_JOBS = 8;

  function handleItemClick(item) {
    let newJobs = [...selectedJobs];
    if (selectedJobs.find(jobID => jobID === item.id)) {
      newJobs = newJobs.filter(jobID => jobID !== item.id);
    } else if (activeTeam.jobs.length + selectedJobs.length < MAX_JOBS) {
      newJobs.push(item.id);
    }

    handleUpdateModalState({ jobsToAdd: newJobs });
  }

  return (
    <DispatchModalList
      data={jobs}
      selected={selectedJobs}
      highlighted={currentJobs}
      columns={columns}
      onClick={handleItemClick}
    />
  );
};

DispatchJobsList.propTypes = {
  jobs: PropTypes.array,
  handleUpdateModalState: PropTypes.func,
  selectedJobs: PropTypes.array,
};

export default DispatchJobsList;
